import { render, staticRenderFns } from "./ContactInformationCard.vue?vue&type=template&id=952013a0&scoped=true&"
import script from "./ContactInformationCard.vue?vue&type=script&lang=js&"
export * from "./ContactInformationCard.vue?vue&type=script&lang=js&"
import style0 from "./ContactInformationCard.vue?vue&type=style&index=0&id=952013a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952013a0",
  null
  
)

export default component.exports